/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react';

import { Theme as MaterialTheme, Grid, Paper } from "@mui/material";

import 'react-toastify/dist/ReactToastify.css';
import TableOpenEntries from '../components/TableOpenEntries';

const ReportsOpenEntriesRoute = (): JSX.Element => {
    
    return <main>
        <Grid container component={Paper} direction="column" wrap="nowrap"
            sx={{
                //paddingTop: theme.spacing(2),
                width: "100%",
                //height: {
                //    xs: "calc(100vh - " + appBarHeight + "px )",
                //    xl: "calc(100vh)"
                //},
                //"& .MuiDataGrid-columnHeaders": { backgroundColor: theme.palette.info.main, color: "white" },
                //"& .MuiDataGrid-footerContainer": { backgroundColor: theme.palette.info.main, color: "white" }
            }}>
            <Grid container minHeight="30rem" overflow="hidden">
                <TableOpenEntries />
            </Grid>
        </Grid>
    </main>

}
export default ReportsOpenEntriesRoute;